<script>
import { ref } from "vue";
import Teeth from "@/components/Project/Teeth";
export default {
  name: "icon",
  components: { Teeth },
  props: {
    data: { type: Object, required: true },
    label: { type: String, default: null },
    path: { type: String, required: true },
    pathSelected: { type: String, required: true},
    width: { type: Number, required: true },
    height: { type: Number, required: false },
    readonly: { type: Boolean, default: false },
    showRemove: { type: Boolean, default: false },
    ids: { type: Array },
    assetsCount: { type: Number, default: 0 },
  },
  emits: ["remove"],
  setup(props, { emit }) {
    const remove = ref([]);

    const imgPath = () => (props.data.selected ? props.pathSelected : props.path);

    const getFromPath = (label) => label.split("/").pop().replace(".svg", "");

    const removeBridge = () => {
      remove.value = props.ids;
      emit("remove", remove.value);
    };

    return { getFromPath, removeBridge, imgPath };
  },
};
</script>

<template>
  <div class="d-flex flex-column justify-content-end">
    <template v-if="$props.label !== null">
      <div class="d-flex align-items-center justify-content-between mb-2">
        <span :class="{ 'text-violet': $props.data.selected }" style="color: lightgray">{{ $props.label }}</span>
        <img
          v-if="!$props.readonly"
          v-show="$props.data.selected && $props.showRemove"
          @click.stop="removeBridge"
          class="remove"
          src="@/assets/icons/close.svg"
          width="25"
          height="25"
          alt="close"
        />
      </div>
    </template>
    <template v-if="!$props.path.includes('teeth')">
      <div class="position-relative d-inline-block m-auto">
        <span
          v-if="$props.assetsCount > 0"
          class="assets-badge badge rounded-pill bg-violet"
          title="File caricati"
        >{{ $props.assetsCount }}</span>
        <img
          class="icon"
          :class="{ 'mt-4': $props.label == null }"
          :src="require(`@/${imgPath()}`)"
          :width="$props.width"
          :height="$props.height"
        />
      </div>
      {{ $t(getFromPath($props.path)) }}
    </template>
    <div v-else class="position-relative d-inline-block m-auto">
      <span
        v-if="$props.assetsCount > 0"
        class="assets-badge badge rounded-pill bg-violet"
        title="File caricati"
      >{{ $props.assetsCount }}</span>
      <Teeth
        :number="$props.data.zone_number"
        :selected="$props.data.selected"
        :width="$props.width"
        :height="$props.height"
        :class="{ 'mt-4': $props.label == null }"
        class="icon"
      />
    </div>
  </div>
</template>

<style scoped>
.icon:hover,
.remove:hover {
  cursor: pointer;
}
.assets-badge {
  position: absolute;
  top: 4px;
  right: 4px;
  z-index: 2;
  font-size: 0.75rem;
  border: 2px solid #fff;
  pointer-events: none;
  min-width: 22px;
}
</style>
